"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var query_exports = {};
__export(query_exports, {
  CollaboratorsQuery: () => CollaboratorsQuery
});
module.exports = __toCommonJS(query_exports);
var import_communication_sdk_types = require("@hcengineering/communication-sdk-types");
var import_result = require("../result");
class CollaboratorsQuery {
  constructor(client, workspace, filesUrl, id, params, callback, initialResult) {
    this.client = client;
    this.workspace = workspace;
    this.filesUrl = filesUrl;
    this.id = id;
    this.params = params;
    this.callback = callback;
    if (initialResult !== void 0) {
      this.result = initialResult;
      void this.notify();
    } else {
      this.result = this.initResult();
      void this.result.then(() => {
        void this.notify();
      });
    }
  }
  static {
    __name(this, "CollaboratorsQuery");
  }
  result;
  isCardRemoved = false;
  async onEvent(event) {
    if (this.isCardRemoved) return;
    switch (event.type) {
      case import_communication_sdk_types.NotificationEventType.AddCollaborators:
        await this.onCollaboratorsAdded(event);
        break;
      case import_communication_sdk_types.NotificationEventType.RemoveCollaborators:
        await this.onCollaboratorsRemoved(event);
        break;
      case import_communication_sdk_types.CardEventType.RemoveCard:
        await this.onCardRemoved(event);
        break;
    }
  }
  async onCollaboratorsAdded(event) {
    if (event.cardId !== this.params.card || event.collaborators.length === 0) return;
    if (this.result instanceof Promise) this.result = await this.result;
    let updated = false;
    for (const account of event.collaborators) {
      if (this.params.limit != null && this.result.length >= this.params.limit) break;
      const existing = this.result.get(account);
      if (existing != null) continue;
      const match = this.match(account);
      if (!match) continue;
      updated = true;
      this.result.push({
        account,
        cardId: event.cardId,
        cardType: event.cardType
      });
    }
    if (updated) {
      void this.notify();
    }
  }
  async onCollaboratorsRemoved(event) {
    if (event.cardId !== this.params.card || event.collaborators.length === 0) return;
    if (this.result instanceof Promise) this.result = await this.result;
    const prevLength = this.result.length;
    let deleted = false;
    for (const account of event.collaborators) {
      const d = this.result.delete(account);
      deleted = deleted || d !== void 0;
    }
    if (!deleted) return;
    if (this.params.limit != null && this.result.length < this.params.limit && prevLength >= this.params.limit) {
      const collaborators = await this.find(this.params);
      this.result = new import_result.QueryResult(collaborators, (c) => c.account);
    }
    void this.notify();
  }
  async onCardRemoved(event) {
    if (this.params.card !== event.cardId) return;
    if (this.result instanceof Promise) this.result = await this.result;
    this.isCardRemoved = true;
    this.result.deleteAll();
    void this.notify();
  }
  async onRequest(event, promise) {
  }
  async initResult() {
    try {
      const res = await this.find(this.params);
      return new import_result.QueryResult(res, (c) => c.account);
    } catch (error) {
      console.error("Failed to initialize query:", error);
      return new import_result.QueryResult([], (c) => c.account);
    }
  }
  async unsubscribe() {
    await this.client.unsubscribeQuery(this.id);
  }
  removeCallback() {
    this.callback = () => {
    };
  }
  setCallback(callback) {
    this.callback = callback;
    void this.notify();
  }
  copyResult() {
    if (this.result instanceof Promise) {
      return void 0;
    }
    return this.result.copy();
  }
  async find(params) {
    if (this.isCardRemoved) return [];
    return await this.client.findCollaborators(params, this.id);
  }
  async notify() {
    if (this.callback == null) return;
    if (this.result instanceof Promise) this.result = await this.result;
    const result = this.result.getResult();
    this.callback(result);
  }
  match(account) {
    if (this.params.account != null) {
      const accounts = Array.isArray(this.params.account) ? this.params.account : [this.params.account];
      if (!accounts.includes(account)) {
        return false;
      }
    }
    return true;
  }
  async refresh() {
    this.result = new import_result.QueryResult([], (c) => c.account);
    this.result = this.initResult();
    void this.result.then(() => {
      void this.notify();
    });
  }
}
//# sourceMappingURL=query.js.map
